import { render, staticRenderFns } from "./ViennaClassification.vue?vue&type=template&id=059a83a4&"
import script from "./ViennaClassification.vue?vue&type=script&lang=js&"
export * from "./ViennaClassification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports